module.exports = {
      id: "icon-social-whatsapp-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-social-whatsapp",
      toString: function () {
        return this.url;
      }
    }